<template>
    <div>
        <svg
            class="sr-only"
            width="0"
            height="0"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <symbol
                    id="star"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    stroke="gray"
                    stroke-width="1"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
                    />
                </symbol>

                <mask id="star-rating-mask">
                    <rect
                        :x="-1 * size * (1 - (rating - absoluteRating))"
                        y="0"
                        :width="size"
                        :height="size"
                        fill="white"
                    />
                </mask>
            </defs>
        </svg>

        <svg
            v-for="i in 5"
            :key="`star-part:${i}`"

            :width="size"
            :height="size"
            
            viewBox="0 0 24 24"
        >
            <use
                href="#star"
                :class="i >= (absoluteRating + 1) ? 'rating--inactive' : 'rating--active'"
            />

            <use
                v-if="i === (absoluteRating + 1)"

                href="#star"
                mask="url(#star-rating-mask)"
                class="rating--active"
            />
        </svg>
    </div>
</template>

<script>
    import { defineComponent } from "vue";

    export default defineComponent({
        name: 'StarRating',

        props: {
            rating: Number,
            size: {
                type: Number,
                default: 20
            }
        },

        computed: {
            absoluteRating: function(){
                return Math.floor(this.rating)
            }
        }
    })
</script>